import i18next from '@/translation/i18n';
// goal visibility
export enum GoalVisibilityFilter {
    ALL = 'ALL',
    VISIBLE = 'VISIBLE',
    HIDDEN = 'HIDDEN',
}

export enum CompletedFilter {
    ALL = 'ALL',
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    WEEK = 'WEEK',
    TWO_WEEK = 'TWO_WEEK',
    MONTH = 'MONTH',
    HIDE_ALL = 'HIDE_ALL',
}

export const CompletedFilterLabel: Record<CompletedFilter, string> = {
    [CompletedFilter.ALL]: i18next.t('filter.period.all'),
    [CompletedFilter.TODAY]: i18next.t('filter.period.today'),
    [CompletedFilter.YESTERDAY]: i18next.t('filter.period.yesterday'),
    [CompletedFilter.WEEK]: i18next.t('filter.period.week'),
    [CompletedFilter.TWO_WEEK]: i18next.t('filter.period.two_week'),
    [CompletedFilter.MONTH]: i18next.t('filter.period.month'),
    [CompletedFilter.HIDE_ALL]: i18next.t('filter.period.hide_all'),
};
